export const environment = {
  production: false,
  apiUrl: 'https://api.simcaq.homolog.fabrica.inf.ufg.br',
  simcaq: {
    featureFlag: {
      'novas-salas': { finalizada: true }, // habilitada em homolog
      '937-consumo-api-datas': { finalizada: true },
      '938-migracao-datas-relatorios-1-e-2': { finalizada: true },
      '939-migracao-datas-relatorios-3-e-4': { finalizada: true },
      '940-atualizacao-de-componentes-de-edicao-pqr': { finalizada: true },
      '885-tela-apresentacao-relatorio-receitas-despesas': { finalizada: true },
      '880-seleciona-local-receitas-despesas': { finalizada: true },
      '882-r5-download-csv': { finalizada: true },
      '883-r5-download-pdf': { finalizada: true },
      '884-tela-relatorio-receitas-despesas': { finalizada: true },
      '585-autenticacao-keycloak': { finalizada: false },
      '1104-creche-idade': { finalizada: true },
      '1108-pqr-minimo-turma': { finalizada: true },
      '1070-coluna-matriculas-fator-ponderacao': { finalizada: true },
      '995-fator-ponderacao-calculo': {
        'exibicao-fator-ponderacao': { finalizada: true },
      },
      '1125-renomear-etapa-20': { finalizada: true },
      '1184-pqr-multiplicador-anual': { finalizada: true },
      '1214-alteracoes-valor-aluno': { finalizada: true },
      '1436-inserir-edicao-nivel-escola': { finalizada: true },
      '1472-salas-necessarias': { finalizada: true },
    },
  },
  auth: {
    url: 'https://api.simcaq.homolog.fabrica.inf.ufg.br:8443',
    realm: 'simcaq',
    clientId: 'simcaq_web',
  },
};
